import * as React from 'react';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../confirmrequest/confirmrequestconfirmbuttoncss';
import { InfoComponentHandler, InfoComponentProps } from './infocomponent';
import { InfoCSSStyle } from './infocss';
import './mytunes-info-style.css';

export class InfoViewImpl extends UIComponentViewImpl<UIDataModel>
{
 
    bindHandlers()
    {   
        this.onCancelClick = this.onCancelClick.bind(this);
        this.onConfirmClick = this.onConfirmClick.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
    }

    draw(props: InfoComponentProps, state: UIComponentState, cssStyle: InfoCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <>
             <div id="mytunes-info-wrapper">
                            {
                                this.getWebView(props, state, cssStyle)
                            }
                   </div>
                   <div id="mytunes-info-col-wrapper">
                            {
                                this.getMobileView(props, state, cssStyle)
                            }
                   </div>
                
            </> 
        );
    }

    getWebView(props: InfoComponentProps, state: UIComponentState, cssStyle: InfoCSSStyle)
    {
        return(
            <div style={cssStyle.getWrapperCSSStyle()}>
            <div style={cssStyle.getHeaderDivCSSStyle()}>
                    <label style={cssStyle.getTitleCSSStyle()}>{props.headerTitle}</label>
                    <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onCloseClick}>
                        <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()}/>
                    </div>
                </div>    
                  <div style={{width:"100%", height:"28px",display:'flex',marginTop:'20px',}}>
                       <div style={{width:"27px",height:'28px',marginRight:'9px',marginLeft:'30px'}}>
                            <img  width="100%" height="100%" src={this.getContext().getResources().getImage("noun_setting.svg")}/>
                       </div>
                       <div style={{width:'200px', height:"25px",lineHeight:'25px', fontSize:"18px",color:'#000000', fontWeight:300, letterSpacing:'0'}}>
                                {this.getContext().getResources().getString(Strings.click_setting_icon)}
                       </div>
                  </div>
                  <div style={{width:'100%',marginLeft:'30px',paddingRight:'30px', height:'auto',color:'#000000', fontSize:'18px', lineHeight:'25px',letterSpacing:"0",fontWeight:300}}>
                         <label style={{width:'100%',height:'25px', paddingTop:'20px',lineHeight:'100%', textAlign:'left'}}>
                             {this.getContext().getResources().getString(Strings.select_one_tune_to_play_it_for_the_full_day_to_all_your_callers)}
                         </label>
                     
                         <label style={{width:'100%',height:'25px',paddingTop:'20px',lineHeight:'100%', textAlign:'left'}}>
                             {this.getContext().getResources().getString(Strings.to_play_a_tune_to_a_specific_callers_or_groups)}
                           </label> 
                           
                  </div>
                  <div style={cssStyle.getVerifyNumberButtonCSSStyle()}>
                    <ButtonComponent onClick={this.onCloseClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.ok)}/>
                </div>
            </div>
        );
    }

    getMobileView(props: InfoComponentProps, state: UIComponentState, cssStyle: InfoCSSStyle)
    {
        return(
            <div style={cssStyle.getMobileWrapperCSSStyle()}>
            <div style={cssStyle.getMobileHeaderDivCSSStyle()}>
                    <label id="mytunes-info-col-mobile-header-title" style={cssStyle.getMobileTitleCSSStyle()}>{props.headerTitle}</label>
                    <div id="mytunes-info-col-mobile-header-icon" style={cssStyle.getMobileCloseIconDivCSSStyle()} onClick={this.onCloseClick}>
                        <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getMobileCloseIconCSSStyle()}/>
                    </div>
                </div>    
                  <div style={{width:"100%", height:"28px",display:'flex',marginTop:'10px',}}>
                       <div style={{width:"20px",height:'20px',marginRight:'9px',marginLeft:'15px'}}>
                            <img  width="100%" height="100%" src={this.getContext().getResources().getImage("noun_setting.svg")}/>
                       </div>
                       <div style={{width:'200px', height:"25px",lineHeight:'25px', fontSize:"14px",color:'#000000', fontWeight:300, letterSpacing:'0'}}>
                       {this.getContext().getResources().getString(Strings.click_setting_icon)}
                       </div>
                  </div>
                  <div style={{width:'100%',paddingLeft:'20px',paddingRight:'15px', height:'auto',color:'#000000', fontSize:'14px', lineHeight:'25px',letterSpacing:"0",fontWeight:300}}>
                         <label style={{width:'100%',height:'25px', paddingTop:'10px',lineHeight:'17px', textAlign:'left'}}>
                             {this.getContext().getResources().getString(Strings.select_one_tune_to_play_it_for_the_full_day_to_all_your_callers)}
                         </label>
                     
                         <label style={{width:'100%',height:'25px',paddingTop:'10px',lineHeight:'17px', textAlign:'left'}}>
                             {this.getContext().getResources().getString(Strings.to_play_a_tune_to_a_specific_callers_or_groups)}
                           </label> 
                           
                  </div>
                  <div style={cssStyle.getMobileVerifyNumberButtonCSSStyle()}>
                    <ButtonComponent onClick={this.onCloseClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.ok)}/>
                </div>
            </div>
        );
    }
    
    protected onCloseClick()
    {
        console.log("on close click");
        (this.getUIComponentHandler() as InfoComponentHandler).closePopup();
    }
    protected onConfirmClick():void
    {
       (this.getUIComponentHandler() as InfoComponentHandler).onOkClick();
    }

     protected onCancelClick():void
    {
        (this.getUIComponentHandler() as InfoComponentHandler).onCancelClick();

    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/info/infoview.tsx